var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_33542",
    "data-name": "Group 33542",
    transform: "translate(-1163.002 -29.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_12",
    "data-name": "Subtraction 12",
    d: "M15719-161a7.011,7.011,0,0,1-7-7,7.011,7.011,0,0,1,7-7,7.008,7.008,0,0,1,7,7,7.008,7.008,0,0,1-7,7Zm0-13.263a6.272,6.272,0,0,0-6.264,6.263,6.272,6.272,0,0,0,6.264,6.263,6.271,6.271,0,0,0,6.266-6.263A6.271,6.271,0,0,0,15719-174.263Zm.368,9.579h-.736v-.737h.736Zm0-2.211h-.736v-.737A.368.368,0,0,1,15719-168a1.472,1.472,0,0,0,1.474-1.474,1.472,1.472,0,0,0-1.474-1.474,1.489,1.489,0,0,0-1.325.832l-.738-.148a2.235,2.235,0,0,1,2.072-1.423,2.211,2.211,0,0,1,2.21,2.211,2.226,2.226,0,0,1-1.578,2.118l-.264.079v.384Z",
    transform: "translate(-14548.999 204.001)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/help-icon.b5743e3d23e98e2851ac5df3e2d1e47e.svg";
export { ForwardRef as ReactComponent };